import { Route } from '@direct-frontend/modules-router';
import { ClientsListAsync } from '#pages/clients';
import { ImportUsersFromExcelAsync } from '#pages/importUsersFromExcel';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import { clientsImportExcelRoute, clientsRoute } from '#shared/lib/routes';

export const clientsRoutes = () =>
    renderWithPermission(
        'clients',
        'read',
        <>
            <Route path={clientsRoute.route} element={<ClientsListAsync />} />
            <Route path={clientsImportExcelRoute.route} element={<ImportUsersFromExcelAsync />} />
        </>
    );
